<template>
	<div class="home">
		<Navigate></Navigate>
		<div class="main">
			<img class="logo" src="@/assets/img/global/logo.jpg" alt="" />
		</div>
		<Copyright></Copyright>
	</div>
</template>

<script>
import Navigate from './views/global/Navigate'
import Copyright from './views/global/Copyright'
export default {
	name: 'Home',
	components: { Navigate, Copyright },
}
</script>

<style scoped>
	.home{ margin: 0; padding: 0; width: 100%; height: 100vh; background: #2e2e2e; display: flex; justify-content: center; align-items: center; }
	.main{ width: 400px; height: 400px; }
	.logo{ width: 400px; height: 400px; }
</style>
